import {
  WidgetType,
  MatchDecorator,
  Decoration,
  ViewPlugin,
  EditorView,
} from "@codemirror/view";

class DealTokenWidget extends WidgetType {
  value;
  label;

  constructor(value, label) {
    super();
    this.value = value;
    this.label = label;
  }

  toDOM() {
    const span = document.createElement("span");

    span.textContent = this.label || this.value;
    span.className = "token-deal";
    return span;
  }
}

const createDealTokenExtension = (dealProperties) => {
  const dealTokenMatcher = new MatchDecorator({
    regexp: /{{(deal\.([a-z0-9_]+)|[a-z0-9_]+)}}/g,
    decoration: (match) => {
      // If match[2] is undefined, it means we have a legacy (non namespaced) token.
      let propName = match[2] || match[1];

      const property = dealProperties.find((prop) => prop.name === propName);
      if (!property) return null;

      return Decoration.replace({
        widget: new DealTokenWidget(propName, property.label),
      });
    },
  });

  return ViewPlugin.fromClass(
    class {
      tokens;
      constructor(view) {
        this.tokens = dealTokenMatcher.createDeco(view);
      }
      update(update) {
        this.tokens = dealTokenMatcher.updateDeco(update, this.tokens);
      }
    },
    {
      decorations: (instance) => instance.tokens,
      provide: (plugin) =>
        EditorView.atomicRanges.of((view) => {
          return view.plugin(plugin)?.tokens || Decoration.none;
        }),
    },
  );
};

export default createDealTokenExtension;
